import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import { useCategory } from 'hooks';
import { category as categoryUtils } from 'utils';
import { CategoryList } from './components';
import './CategoryFilter.scss';

const CategoryFilter = ({ className }) => {
    const category = useCategory();

    const rootClassnames = classnames(
        'category-filters',
        'filter--xs-slide-up',
        className,
    );

    const formatedCategories = categoryUtils.formatCategoryData({
        categoryId: category.id,
        data: {
            // eslint-disable-next-line camelcase
            child_categories: category.context?.child_categories,
            // eslint-disable-next-line camelcase
            sibling_categories: category.context?.sibling_categories,
            // eslint-disable-next-line camelcase
            recommended_categories: category.context?.recommended_categories,
        },
    });
    return (
        <div className={rootClassnames} data-qa="categories.last_id">
            <CategoryList values={formatedCategories} />
        </div>
    );
};

CategoryFilter.propTypes = {
    className: string,
};

CategoryFilter.defaultProps = {
    className: undefined,
};

CategoryFilter.displayName = 'CategoryFilter';

export default CategoryFilter;
